import { render, staticRenderFns } from "./im-custom-surgery.vue?vue&type=template&id=23577418&scoped=true"
import script from "./im-custom-surgery.vue?vue&type=script&lang=js"
export * from "./im-custom-surgery.vue?vue&type=script&lang=js"
import style0 from "./im-custom-surgery.vue?vue&type=style&index=0&id=23577418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23577418",
  null
  
)

export default component.exports